// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1_iER","cls2":"AuthorHeader-cls2__PI AuthorHeader-cls1_iER"};